// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Link from "../Link.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as StatsTooltip from "./StatsTooltip.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";

function TraitInfoRect$TierRow(Props) {
  var traitId = Props.traitId;
  var rank = Props.rank;
  var stats = Props.stats;
  var place = stats[1];
  var popularity = stats[0];
  return React.createElement("div", {
              className: CssJs.merge([
                    "flex items-center",
                    CssJs.style([
                          CssJs.padding2(CssJs.px(4), CssJs.zero),
                          CssJs.fontWeight(CssJs.normal),
                          CssJs.color(CssJs.rgba(255, 255, 255, {
                                    NAME: "num",
                                    VAL: 0.87
                                  }))
                        ])
                  ])
            }, React.createElement("div", undefined), React.createElement(TraitTooltip.make, {
                  trait: traitId,
                  rank: rank,
                  children: React.createElement(TraitImage.PlainIcon2.make, {
                        traitId: traitId,
                        rank: rank,
                        size: 28
                      })
                }), React.createElement(Tooltip.make, {
                  title: React.createElement(StatsTooltip.make, {
                        stats: [
                          [
                            "Play rate",
                            (popularity * 8).toFixed(2) + "/8"
                          ],
                          [
                            "Place",
                            place.toFixed(2)
                          ],
                          [
                            "Top4",
                            Global.formatPct3(stats[2])
                          ],
                          [
                            "Win",
                            Global.formatPct3(stats[3])
                          ]
                        ]
                      }),
                  children: React.createElement("div", {
                        className: "ml-2 flex"
                      }, React.createElement("div", {
                            className: "w-8"
                          }, Global.toFixed(undefined, popularity * 8)), React.createElement("div", {
                            className: CssJs.merge([
                                  "text-right",
                                  CssJs.style([
                                        CssJs.width(CssJs.px(36)),
                                        CssJs.marginLeft(CssJs.px(4)),
                                        CssJs.paddingLeft(CssJs.px(4)),
                                        CssJs.borderLeft(CssJs.px(1), CssJs.solid, CssJs.rgba(255, 255, 255, {
                                                  NAME: "num",
                                                  VAL: 0.6
                                                }))
                                      ])
                                ])
                          }, Global.toFixed(undefined, place)))
                }));
}

var TierRow = {
  make: TraitInfoRect$TierRow
};

function TraitInfoRect(Props) {
  var onTraitSelected = Props.onTraitSelected;
  var stats1 = Props.stats1;
  var stats2 = Props.stats2;
  var stats3 = Props.stats3;
  var traitId = Props.traitId;
  var set = TftSet.use(undefined);
  var maxRank = Sd.traitRankCounts(traitId, set).length;
  var aperture = ApertureCtx.useValue(undefined);
  var tmp = {
    prefetch: false,
    route: {
      TAG: /* Stats */0,
      _0: {
        TAG: /* Trait */5,
        trait: traitId,
        rank: 1,
        aperture: aperture
      }
    },
    children: React.createElement("div", {
          className: "flex flex-col text-sm p-2 bg-bg2 h-[124px] cursor-pointer"
        }, stats1 !== undefined ? React.createElement(TraitInfoRect$TierRow, {
                traitId: traitId,
                rank: 1,
                stats: stats1
              }) : null, stats2 !== undefined ? React.createElement(TraitInfoRect$TierRow, {
                traitId: traitId,
                rank: 2,
                stats: stats2
              }) : null, stats3 !== undefined && maxRank >= 3 ? React.createElement(TraitInfoRect$TierRow, {
                traitId: traitId,
                rank: 3,
                stats: stats3
              }) : null)
  };
  var tmp$1 = onTraitSelected !== undefined ? (function (param) {
        return Curry._2(onTraitSelected, traitId, 1);
      }) : undefined;
  if (tmp$1 !== undefined) {
    tmp.onClick = Caml_option.valFromOption(tmp$1);
  }
  return React.createElement(Link.make, tmp);
}

var make = TraitInfoRect;

export {
  TierRow ,
  make ,
  
}
/* Sd Not a pure module */
